import React from 'react';
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import { DASHBOARD_COLORS } from './dashboardStyles';

/** Index 0 = Sunday … 6 = Saturday (matches Date.getDay()). */
const DAILY_QUOTES = [
  'Take time to reflect, recharge, and prepare for a productive new week.',
  'New week, new goals, new opportunities to achieve success.',
  'Stay consistent. Progress made today brings results tomorrow.',
  'Halfway through the week — keep pushing toward your targets.',
  'Success comes from staying focused even on the busiest days.',
  'Finish the week strong and let your hard work speak for itself.',
  'Smart work today builds a stronger business for tomorrow.',
];

const getTimeGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
};

const getFirstName = (fullName) => {
  if (!fullName || !String(fullName).trim()) return 'there';
  return String(fullName).trim().split(/\s+/)[0];
};

const getDailyQuote = () => DAILY_QUOTES[new Date().getDay()];

const DashboardGreeting = ({ userName, embedded = false }) => {
  const greeting = getTimeGreeting();
  const firstName = getFirstName(userName);
  const dateLine = format(new Date(), 'EEEE, d MMMM yyyy');
  const subtitle = `${dateLine} — ${getDailyQuote()}`;

  return (
    <Box sx={embedded ? undefined : { mb: 3 }}>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          color: DASHBOARD_COLORS.text,
          fontSize: { xs: '1.35rem', sm: '1.5rem' },
          lineHeight: 1.3,
        }}
      >
        {greeting}, {firstName}{' '}
        <Box component="span" sx={{ fontSize: '1.1em' }} aria-hidden>
          👋
        </Box>
      </Typography>
      <Typography variant="body2" sx={{ color: DASHBOARD_COLORS.textMuted, mt: 0.75 }}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default DashboardGreeting;
